const splitDate = (date: string | undefined): { day: string; month: string; year: string } => {
    const [day = '', month = '', year = ''] = date?.split(' ') || [];
    return { day, month, year };
};

export const formatDateRange = (startDate: string | undefined, endDate: string | undefined): string => {
    const { day: startDay, month: startMonth, year: startYear } = splitDate(startDate);
    const { day: endDay, month: endMonth, year: endYear } = splitDate(endDate);

    let dateRange = '';
    if (startDay && startMonth && startYear) {
        if (startMonth === endMonth && startYear === endYear && startDay !== endDay) {
            dateRange = `${startDay} - ${endDay} ${startMonth} ${startYear}`;
        } else if (startYear === endYear && startMonth !== endMonth) {
            dateRange = `${startDay} ${startMonth} - ${endDay} ${endMonth} ${startYear}`;
        } else if (startYear !== endYear) {
            dateRange = `${startDay} ${startMonth} ${startYear} - ${endDay} ${endMonth} ${endYear}`;
        } else {
            dateRange = `${startDay} ${startMonth} ${startYear}`;
        }
    }

    return dateRange;
};
